import React from "react";
import { Modal } from "react-bootstrap";

import Button from "../Button/Button";
import FormInput from "../Form-Input/FormInput";
import "./styles.scss";

const AddUser = (props) => {
  return (
    <React.Fragment>
      <Modal
        show={props.showAddUserModal}
        onHide={props.handleAddUserModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={props.handleAddUserSubmit}>
            <FormInput
              icon="fa fa-user icon"
              size="15px"
              type="text"
              name="name"
              placeholder="Name"
              value={props.name}
              handleChange={props.handleChange}
            />

            <FormInput
              icon="fa fa-envelope icon"
              size="13px"
              type="email"
              name="email"
              placeholder="Email"
              className="form-control shadow-none"
              value={props.email}
              handleChange={props.handleChange}
            />

            <FormInput
              icon="fa fa-phone icon"
              type="number"
              name="phoneNumber"
              placeholder="Phone Number"
              className="form-control shadow-none"
              value={props.phoneNumber}
              handleChange={props.handleChange}
            />

            <Button
              type="submit"
              value="Add User"
              className="btn btn-primary btn-block add-user-btn shadow-none"
            />
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default AddUser;
